<template>
  <section class="form-list flex">
    <div
      v-show="isShowStoreSelect"
      class="loading-box"
      @click="isShowStoreSelect = false"
    >
      <el-form
        class="loading-form"
        label-position="left"
        label-width="80px"
      >
        <el-form-item label="所属门店">
          <v-select-store v-model="storeId" @input="load"/>
        </el-form-item>
      </el-form>
    </div>

    <div class="profile-box">
      <div class="container-item profile">
        <v-avatar :value="store.cover" :size="130"/>
        <div class="nickname-box">
          <div class="profile-info store-name-box" @click="changeStore">
            <span class="nickname">{{ store.store_name }}</span>
          </div>
          <div class="profile-info">店长：{{ store.manager_names }}</div>
        </div>
      </div>

      <div class="container-item">
        <div v-if="isAdministratorOrManager" class="table-title">
          <h3>支出统计</h3>
          <el-button type="primary" size="mini" @click="showDialog">编辑</el-button>
        </div>
        <template v-if="isAdministratorOrManager">
          <div class="store-info-item">
            <v-icon name="rent" class="store-info-icon"/>
            每月房租：<span class="pay-count">¥ {{ store.rent }}</span>
          </div>

          <div class="store-info-item">
            <v-icon name="cost" class="store-info-icon"/>
            平均月度成本：<span class="pay-count">¥ {{ store.cost }}</span>
          </div>

          <div class="store-info-item">
            <v-icon name="revenue-sharing" class="store-info-icon"/>
            总部提成比例：<span class="pay-count">{{ store.revenue_sharing }} %</span>
          </div>
        </template>

        <template v-if="isReceptionist">
          <div v-for="v in myStaffSalaries" :key="v.id || v.administrator_id" class="store-info-item">
            <v-icon name="task-income" class="store-info-icon"/>
            业绩任务：{{ v.task_income }} 元
          </div>
        </template>

        <div class="store-info-item">
          <v-icon name="teacher-manage" class="store-info-icon"/>
          常驻老师：<span class="primary-color bolder">{{ teacherCount }}</span>
        </div>
      </div>

      <div class="container-item last-container-item primary-background">
        <div class="table-title">
          <h3>老师列表</h3>
          <router-link
            :to="isAdministratorOrManager ? RouteConfig.teacherSalaryList.to() : RouteConfig.teacherList.to()"
            class="edit-button"
          >
            <el-button type="primary" size="mini">管理</el-button>
          </router-link>
        </div>

        <div class="flex-wrap">
          <v-avatar-nickname
            v-for="v in teachers"
            :key="v.id"
            :value="v.avatar"
            :nickname="v.nickname"
            :link-page-name="RouteConfig.teacherDetail.name"
            :link-page-id="v.id"
            class="teacher-item"
          />
        </div>
        <el-pagination
          v-show="teacherCount > teacherPageSize"
          class="pagination"
          layout="prev, pager, next"
          :page-size="teacherPageSize"
          :total="teacherCount"
          background
          @current-change="(page) => getTeachers(page)"
        />
      </div>
    </div>

    <div class="record-list-box">
      <div class="container-item primary-background" v-if="isAdministratorOrManager">
        <h3 class="table-title">本月店员薪资设置</h3>
        <el-table
          :data="staffSalaries"
          fit
          highlight-current-row
          class="salary-table"
        >
          <el-table-column label="员工" width="160" align="center">
            <template v-slot="{ row }">
              <v-select-administrator
                :store-id="storeId"
                v-model="row.administrator_id"
                placeholder="请选择员工"
                @change="(id) => getStaffSalary(id, row)"
              />
            </template>
          </el-table-column>
          <el-table-column label="底薪" width="124" align="center" prop="base_pay">
            <template v-slot="{ row }">
              {{ row.base_pay }}
            </template>
          </el-table-column>
          <el-table-column label="业绩任务" width="124" align="center">
            <template v-slot="{ row }">
              <v-input-money
                class="salary-input"
                :is-plain="true"
                v-model="row.task_income"
              />
            </template>
          </el-table-column>

          <el-table-column label="未完成底薪比例" width="124" align="center">
            <template v-slot="{ row }">
              <div class="flex-center">
                {{ row.base_pay_rate }}
                <span class="percentage">%</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="完成后提成比例" width="124" align="center">
            <template v-slot="{ row }">
              <div class="flex-center">
                {{ row.commission_rate }}
                <span class="percentage">%</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="公司社保" align="center" width="124" prop="social_insurance">
            <template v-slot="{ row }">
              {{ row.social_insurance }}
            </template>
          </el-table-column>
          <el-table-column label="门店社保" align="center" width="124" prop="store_insurance">
            <template v-slot="{ row }">
              {{ row.store_insurance }}
            </template>
          </el-table-column>
          <el-table-column label="个人社保" align="center" width="124" prop="personal_insurance">
            <template v-slot="{ row }">
              {{ row.personal_insurance }}
            </template>
          </el-table-column>

          <el-table-column
            label="操作"
            align="center"
            width="120"
          >
            <template v-slot="{ $index, row }">
              <el-popover placement="top" v-model="row.showTip">
                <p>确认要删除吗？</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="row.showTip = false">取消</el-button>
                  <el-button
                    type="primary"
                    size="mini"
                    @click="deleteStaffSalaries($index, staffSalaries)"
                  >
                    确认
                  </el-button>
                </div>
                <template slot="reference">
                  <el-button class="edit-button" size="mini" type="danger">删除</el-button>
                </template>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
        <div class="submit-button-box">
          <el-button class="add-button" type="primary" @click="addStaffSalaries">新增一项</el-button>
          <el-button type="success" @click="updateStaffSalaries" :loading="isSaving">保存设置</el-button>
        </div>
      </div>

      <div class="container-item primary-background">
        <h3 class="table-title">本月业绩收入</h3>
        <div v-show="incomes.length" id="income-box"></div>
          <template v-if="incomes.length">
            <template v-for="v in visibleIncomePercentages">
              <div
                :key="v.id"
                class="flex-align-center progress-item"
              >
                <div>{{ v.name }}</div>
                <div class="progress-bar">
                  <el-progress
                    :text-inside="true"
                    :stroke-width="26"
                    :percentage="v.percentage > 100 ? 100 : v.percentage"
                    :status="v.percentage >= 100 ? 'exception' : ''"
                    :format="() => handleFormatProgress(v.percentage)"
                  />
                </div>
              </div>
            </template>
          <div class="count-bar">
            本月新生+老生+小程序预约+课次券+代金券收入共收入 <span class="income-count">{{ allIncome | toYuan }}</span> 元，其中新生 <span class="income-count">{{ newIncome | toYuan }}</span> 元，老生 <span class="income-count">{{ oldIncome | toYuan }}</span> 元，小程序预约收入 <span class="income-count">{{ reservationIncome | toYuan }}</span> 元，课次券收入 <span class="income-count">{{ cardTicketIncome | toYuan }}</span> 元，代金券收入 <span class="income-count">{{ voucherIncome | toYuan }}</span> 元。
          </div>
        </template>
        <div v-else>暂无收入数据</div>
      </div>

      <div class="container-item primary-background">
        <h3 class="table-title">本月考勤</h3>
        <el-table
          v-if="checks.length"
          :data="checks"
          fit
          highlight-current-row
          class="primary-background"
        >
          <v-column-avatar label="管理员"/>
          <el-table-column label="打卡类型" align="center" prop="checkin_type"/>
          <v-column-time value="规定时间" field="sch_checkin_time" sortable=""/>
          <el-table-column label="打卡时间" align="center">
            <template v-slot="{ row }">
              <span v-if="row.exception_type === '未打卡'">未打卡</span>
              <span v-else>{{ row.checkin_time | timeToYmdHi }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div v-else>暂无打卡数据</div>
      </div>
    </div>

    <el-dialog
      title="修改支出信息"
      :lock-scroll="false"
      :close-on-click-modal="false"
      :visible.sync="isShowDialog"
      width="400px"
    >
      <div class="dialog-box">
        <el-form :model="storeUpdateData" ref="course">
          <el-form-item label="每月房租">
            <v-input-money v-model="storeUpdateData.rent"/>
          </el-form-item>
          <el-form-item label="每月成本">
            <v-input-money v-model="storeUpdateData.cost"/>
          </el-form-item>
        </el-form>

        <div class="flex-justify-end">
          <el-button @click="isShowDialog = false">取消</el-button>
          <el-button :loading="isUpdating" type="primary" @click="handleUpdateStore">保存修改</el-button>
        </div>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { show, updateRent } from '@/api/store';
import { index as getTeachers } from '@/api/teacher';
import { getStaffSalariesForCurrentMonth, update } from '@/api/staff-salary';
import { getCheckinListByStoreId, getSalaryByAdministratorId } from '@/api/administrator';
import { getMonthlyIncomes } from '@/api/daily-report';
import { timeAgoWithYmd, plus, dividedBy, toYuan, toCent, decimalPlaces }  from '@/filters';
import * as echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';

export default {
  name: RouteConfig.home.name,
  data: () => ({
    RouteConfig,
    isShowDialog: false,
    isShowStoreSelect: false,
    isSaving: false,
    isUpdating: false,
    isDestroyed: false,
    teacherCount: 0,
    teacherPageSize: 12,
    storeId: 0,
    allIncome: 0,
    newIncome: 0,
    oldIncome: 0,
    reservationIncome: 0,
    cardTicketIncome: 0,
    voucherIncome: 0,
    incomePercentages: [],
    store: {
      store_name: '',
      cover: '',
      manager_names: '',
      rent: 0,
      cost: 0,
      revenue_sharing: 0,
      task_enabled: 1,
      task_incomes: [],
      update_time: 0,
    },
    salary: {
      base_pay: 0,
      social_insurance: 0,
      store_insurance: 0,
      personal_insurance: 0,
      task_income: 0,
      base_pay_rate: 0,
      commission_rate: 0,
    },
    storeUpdateData: {
      rent: 0,
      cost: 0,
    },
    staffSalaries: [],
    incomes: [],
    newIncomes: [],
    oldIncomes: [],
    reservationIncomes: [],
    cardTicketIncomes: [],
    voucherIncomes: [],
    days: [],
    teachers: [],
    checks: [],
    myChart: false,
  }),
  computed: {
    ...mapGetters([
      'isAdministratorOrManager',
      'isAdministrator',
      'isReceptionist',
      'userStoreId',
      'userId',
    ]),
    myStaffSalaries() {
      return this.staffSalaries.filter(v => v.administrator_id === this.userId);
    },
    visibleIncomePercentages() {
      return this.incomePercentages.filter((v) => {
        if (!v.percentage) return false;
        return this.isAdministratorOrManager || v.id === this.userId;
      });
    },
  },
  beforeMount() {
    this.storeId = this.isAdministrator ? 1 : this.userStoreId;
    this.load();
  },
  beforeDestroy() {
    this.isDestroyed = true;
  },
  methods: {
    handleFormatProgress: (percentage) => `已完成 ${percentage} %`,
    changeStore() {
      if (!this.isAdministrator) return;
      this.isShowStoreSelect = true;
    },
    getCurrentMonthDays(){
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let d = new Date(year, month, 0);
      return d.getDate();
    },
    async load() {
      this.isShowStoreSelect = false;
      await Promise.all([
        this.show(),
        this.getStaffSalaries(),
        this.getIncomes(),
        this.getTeachers(),
        this.getCheckinListByStoreId(),
      ]);

      this.$nextTick(this.initChart);
    },
    showDialog() {
      Object.assign(this.storeUpdateData, {
        rent: this.store.rent,
        cost: this.store.cost,
      });
      this.isShowDialog = true;
    },
    computeIncome: incomes => incomes.reduce((total, num) => plus(total, num), 0),
    initChart() {
      const { incomes, newIncomes, oldIncomes, days } = this;
      if (this.isDestroyed || !incomes.length) return;

      const daysLength = days.length;
      const incomePercentages = [];
      const legends = ['新生+老生+预约+课次券+代金券总收入', '新生+老生+预约+课次券+代金券总收入均值'];
      const allIncome = this.computeIncome(incomes);
      const newIncome = this.computeIncome(newIncomes);
      const oldIncome = this.computeIncome(oldIncomes);
      const reservationIncome = this.computeIncome(this.reservationIncomes);
      const cardTicketIncome = this.computeIncome(this.cardTicketIncomes);
      const voucherIncome = this.computeIncome(this.voucherIncomes);
      const series = [
        {
          name: '新生+老生+预约+课次券+代金券总收入',
          data: incomes.map(item => toYuan(item)),
          type: 'line',
        },
        {
          name: '新生+老生+预约+课次券+代金券总收入均值',
          data: new Array(daysLength).fill(toYuan( dividedBy(allIncome, daysLength) )),
          type: 'line',
        },
      ];

      const currentMonthDays = this.getCurrentMonthDays();
      this.staffSalaries.forEach(item => {
        // 前台职位并且不是本人的号则跳过
        if (this.isReceptionist && item.administrator_id !== this.userId) return;

        const nickname = item.administrator_id === this.userId ? '我的' : item.nickname;
        const name = `${nickname}业绩任务均值`;

        legends.push(name);
        series.push({
          name,
          data: new Array(currentMonthDays).fill( decimalPlaces( dividedBy(item.task_income, currentMonthDays) ) ),
          type: 'line',
        });
        incomePercentages.push({
          name: `${nickname}本月业绩任务`,
          id: item.administrator_id,
          percentage: item.task_income ? toCent( dividedBy(allIncome, toCent(item.task_income) ) ) : 0,
        });
      });

      Object.assign(this, {
        allIncome,
        newIncome,
        oldIncome,
        reservationIncome,
        cardTicketIncome,
        voucherIncome,
        incomePercentages,
      });

      if (!this.myChart) {
        this.myChart = echarts.init(document.getElementById('income-box'));
      }

      this.myChart.setOption({
        legend: {
          data: legends,
        },
        tooltip: {
          trigger: 'axis',
        },
        xAxis: {
          data: days.map(item => timeAgoWithYmd(item)),
        },
        yAxis: {},
        series,
      }, true);
    },
    async show() {
      const { isError, data } = await show(this.storeId);
      if (isError) return;

      const { store } = this;
      Object.keys(data).forEach(key => {
        if (key in store) store[key] = data[key];
      });
      store.cost = toYuan(store.cost);
      store.rent = toYuan(store.rent);
      store.revenue_sharing = toYuan(store.revenue_sharing);
    },
    addStaffSalaries() {
      this.staffSalaries.push({
        administrator_id: '',
        base_pay: 0,
        task_income: 0,
        personal_insurance: 0,
        social_insurance: 0,
        store_insurance: 0,
      });
    },
    deleteStaffSalaries(index, rows) {
      rows.splice(index, 1);
    },
    async getStaffSalary(id, row) {
      const { isError, data } = await getSalaryByAdministratorId({
        administrator_id: id,
        store_id: this.storeId,
      });
      if (isError) return;

      Object.assign(row, {
        base_pay: toYuan(data.base_pay),
        task_income: toYuan(data.task_income),
        commission_rate: toYuan(data.commission_rate),
        base_pay_rate: toYuan(data.base_pay_rate),
        social_insurance: toYuan(data.social_insurance),
        store_insurance: toYuan(data.store_insurance),
        personal_insurance: toYuan(data.personal_insurance),
      });
    },
    async getStaffSalaries() {
      const { isError, data } = await getStaffSalariesForCurrentMonth(this.storeId);
      if (isError) return;

      data.forEach(v => {
        v.base_pay = toYuan(v.base_pay);
        v.task_income = toYuan(v.task_income);
        v.commission_rate = toYuan(v.commission_rate);
        v.base_pay_rate = toYuan(v.base_pay_rate);
        v.social_insurance = toYuan(v.social_insurance);
        v.store_insurance = toYuan(v.store_insurance);
        v.personal_insurance = toYuan(v.personal_insurance);
      });
      this.staffSalaries = data;
    },
    async updateStaffSalaries() {
      if (this.isSaving) return;

      this.isSaving = true;

      const staff_salaries = JSON.parse(JSON.stringify(this.staffSalaries));
      staff_salaries.forEach(v => {
        v.base_pay = toCent(v.base_pay);
        v.task_income = toCent(v.task_income);
        v.commission_rate = toCent(v.commission_rate);
        v.base_pay_rate = toCent(v.base_pay_rate);
        v.social_insurance = toCent(v.social_insurance);
        v.store_insurance = toCent(v.store_insurance);
        v.personal_insurance = toCent(v.personal_insurance);
      });

      const { isError } = await update({
        store_id: this.storeId,
        staff_salaries,
      });
      this.isSaving = false;
      if (isError) return;

      this.$message.success('已成功保存薪资设置！');
      await this.getStaffSalaries();
      this.$nextTick(this.initChart);
    },
    async getIncomes() {
      const { isError, data } = await getMonthlyIncomes(this.storeId);
      if (isError || !Array.isArray(data.new_incomes) || !Array.isArray(data.days)) return;

      const incomes = [];
      data.new_incomes.forEach((income, index) => {
        incomes.push(plus(
          data.old_incomes[index],
          income,
          data.reservation_incomes[index] || 0,
          data.card_ticket_incomes[index] || 0,
          (data.voucher_incomes || [])[index] || 0,
        ));
      });

      Object.assign(this, {
        incomes,
        newIncomes: data.new_incomes,
        oldIncomes: data.old_incomes,
        reservationIncomes: data.reservation_incomes || [],
        cardTicketIncomes: data.card_ticket_incomes || [],
        voucherIncomes: data.voucher_incomes || [],
        days: data.days,
      });
    },
    async getTeachers(page = 1) {
      const { storeId, teacherPageSize } = this;
      const { isError, data } = await getTeachers({ store_id: storeId, page, size: teacherPageSize });
      if (isError) return;

      this.teachers = data.list;
      this.teacherCount = data.count;
    },
    async getCheckinListByStoreId() {
      const { isError, data } = await getCheckinListByStoreId(this.storeId);
      if (isError) return;

      this.checks = data;
    },
    async handleUpdateStore() {
      if (this.isUpdating) return;

      this.isUpdating = true;
      const { isError } = await updateRent(
        this.storeId,
        {
          rent: toCent(this.storeUpdateData.rent),
          cost: toCent(this.storeUpdateData.cost),
          update_time: this.store.update_time,
        },
      );
      this.isUpdating = false;
      if (isError) return;

      this.isShowDialog = false;
      this.$message.success('已成功保存支出信息！');
      this.show();
    },
  },

};
</script>

<style src="../student/detail.css" scoped/>
<style src="./index.css" scoped/>
<style src="./index-phone.css" scoped/>
